import { ProfileHeader } from "../components/ProfileHeader";

export function ProfilePage() {
    return <ProfileHeader />;
}
